import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "waiting",
  "use": "waiting-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"waiting\"><rect width=\"1.2\" height=\"1.2\" x=\"11.4\" y=\"15\" rx=\".6\" /><rect width=\"1.2\" height=\"6\" x=\"11.4\" y=\"8\" rx=\".6\" /><path d=\"M12 4a8 8 0 110 16 8 8 0 010-16zm0 1.067a6.933 6.933 0 100 13.866 6.933 6.933 0 000-13.866z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol